<section class="page-container">
    <div class="flex min-w-0 items-center justify-between gap-4">
      <h1 class="main-heading min-w-0">Factory Standard Equipment & Items</h1>
      <app-navpath class="hidden md:block"></app-navpath>
    </div>
  
    <div class="mb-2 mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button class="shorter-btn misc-btn" (click)="updateDeliveryCer()">
        <fa-icon [icon]="faSave" class="mr-1"></fa-icon>Update
      </button>
    </div>
  
    <div class="content-container">
      <!-- Category selection -->
      <app-data-form
        [dataFields]="categoryField"
        [dataName]="'categoryField'"
        [columns]="1"
        (updateFields_child)="onCategoryChange($event.fields[0].value)"
      ></app-data-form>
  
      <!-- Delivery items form -->
      <app-data-form
        [dataFields]="itemsFields"
        [dataName]="'itemsFields'"
        [columns]="2"
      ></app-data-form>
    </div>
  </section>
  
